import { Alert, Button, Form, Input, Row, Spin, Typography } from 'antd';

import { OFF } from '@app/constants';
import {
  EMAIL_LENGTH_VALIDATION,
  EMAIL_TYPE_VALIDATION,
  ERROR_REQUIRED_FIELD,
} from '@app/constants/alerts';
import { PNG } from '@app/constants/fileMimeTypes';

import type { FormInstance } from 'antd';
import type { ChangeEventHandler, FC } from 'react';

import '@pages/Authorization/ui/components/Email.scss';

interface EmailProps {
  captchaChangeHandler: ChangeEventHandler<HTMLInputElement>;
  captchaImage: string;
  clearServerErrorHandler: () => void;
  emailChangeHandler: ChangeEventHandler<HTMLInputElement>;
  finishHandler: (values: { captcha: string; email: string }) => Promise<void>;
  form: FormInstance<{ captcha: string; email: string }>;
  isPageLoader: boolean;
  isSubmitLoader: boolean;
  serverError: string;
}

export const Email: FC<EmailProps> = ({
  captchaChangeHandler,
  captchaImage,
  clearServerErrorHandler,
  emailChangeHandler,
  finishHandler,
  form,
  isPageLoader,
  isSubmitLoader,
  serverError,
}) => (
  <Form
    form={form}
    className="Email"
    name="basic"
    initialValues={{ remember: true }}
    autoComplete={OFF}
    onFinish={finishHandler}
  >
    {isPageLoader ? (
      <Row justify="center" style={{ marginBottom: '24px' }}>
        <Spin />
      </Row>
    ) : (
      <>
        <Typography className="Email__label">
          Введите адрес электронной почты
        </Typography>
        <Form.Item
          name="email"
          normalize={(value) => value?.trim() || ''}
          rules={[
            { required: true, message: ERROR_REQUIRED_FIELD },
            EMAIL_TYPE_VALIDATION,
            EMAIL_LENGTH_VALIDATION,
          ]}
        >
          <Input
            maxLength={100}
            className="Email__field"
            size="large"
            onChange={emailChangeHandler}
          />
        </Form.Item>
      </>
    )}

    {captchaImage && (
      <>
        <Typography className="Email__captcha-label">
          Защита от ботов
        </Typography>
        <div className="Email__captcha-container">
          <img
            className="Email__captchaImage"
            src={`data:${PNG};base64,${captchaImage}`}
            alt="captcha-image"
          />
          <Form.Item
            label={null}
            name="captcha"
            rules={[{ required: true, message: ERROR_REQUIRED_FIELD }]}
          >
            <Input
              className="Email__captcha-field"
              size="large"
              onChange={captchaChangeHandler}
            />
          </Form.Item>
        </div>
      </>
    )}

    {serverError && (
      <div className="Email__alert-container">
        <Alert
          className="Email__alert"
          description={serverError}
          type="error"
          showIcon
          onClick={clearServerErrorHandler}
        />
      </div>
    )}

    <Form.Item className="Email__button-container">
      <Button
        data-testid="login-button"
        className="Email__sign-in-button"
        loading={isSubmitLoader}
        type="primary"
        size="large"
        htmlType="submit"
      >
        Войти
      </Button>
    </Form.Item>
  </Form>
);
